import { Line } from "react-chartjs-2";

import { CHART_COLORS, lineChartOptions } from "../../config";
import { ChartProps, DataSet } from "../../types";

function LineChart(props: ChartProps) {
  return (
    <Line
      options={lineChartOptions}
      data={{
        labels: props.labels,
        datasets: props.datasets.map((dataset: DataSet, index: number) => {
          return {
            borderColor: CHART_COLORS[index],
            // `+ "80` effectively sets the opacity to 0.5.
            backgroundColor: CHART_COLORS[index] + "80",
            data: dataset.data,
            label: dataset.label,
            // Sets the "curvature" of the line.
            tension: 0.25,
          };
        }),
      }}
    />
  );
}

export default LineChart;
